import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  p: 1,
  width: '100%',
};

export const productText: SxStyle = {
  fontSize: '10px',
  color: (p) => p.palette.primary[400],
};

export const skeleton: SxStyle = {
  width: '100%',
  height: '100%',
};

export const skeletonWrapper: SxStyle = {
  width: '100%',
  height: '100%',
  padding: (p) => p.spacing(2),
};
